import React from 'react';
import { Button } from 'antd';
import { Translate } from '@above-the-treeline/localization';
import { RegistrationTypes } from './RegistrationEnums';
import './registrationModal.less';

type RegistrationModalAnchorsProps = {
	handleClick: (currentType: string) => void;
};

export default function RegistrationModalAnchors({
	handleClick,
}: RegistrationModalAnchorsProps): JSX.Element {
	return (
		<>
			<Button
				type="primary"
				className="orange-ant-btn"
				shape="round"
				onClick={() => handleClick(RegistrationTypes.SignUp)}>
				<Translate id={RegistrationTypes.SignUp} />
			</Button>
			<Button
				shape="round"
				onClick={() => handleClick(RegistrationTypes.LogIn)}>
				<Translate id={RegistrationTypes.LogIn} />
			</Button>
		</>
	);
}
